var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyInsight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.07,
    d: "M82 82.07a15.5 15.5 0 1 0-15 0V91h15v-8.93z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4 95.04H65.9a.5.5 0 0 0-.5.5v1.98a2.49 2.49 0 0 0 2.47 2.48h13.49a2.49 2.49 0 0 0 2.48-2.48v-2c.02-.25-.2-.48-.45-.48zM92.54 63.63a1.72 1.72 0 0 0-2.13-1.21 1.73 1.73 0 0 0-1.22 2.13c.3 1.1.5 2.75.5 4.04 0 5.75-3.2 10.93-8.36 13.51-.59.3-.96.9-.96 1.56v5.83H68.89V83.7c0-.67-.37-1.26-.97-1.56A15.12 15.12 0 1 1 85.2 57.83c.67.7 1.76.7 2.46.03.69-.67.69-1.76.02-2.46a18.6 18.6 0 1 0-22.26 29.35v6.47c0 .97.77 1.74 1.74 1.74h14.97c.47 0 .89-.17 1.24-.52.32-.32.52-.77.52-1.24v-6.52c5.77-3.32 9.3-9.4 9.3-16.11a22.87 22.87 0 0 0-.65-4.94z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyInsight);
export default __webpack_public_path__ + "static/media/empty-insight.9a3cc64d.svg";
export { ForwardRef as ReactComponent };